<template>
  <div class="section4">
    <div class="bg"></div>
    <div class="content-title">
      <img src="../../assets/img/black-vip-logo.png" alt="" />
      <span>官方认证门店</span>
    </div>
    <!-- 下拉框选项 -->
    <div class="content1">
      <div class="choose-address">
      <div class="city-choose-item">
        <div class="city-choose-item--title">省份</div>
        <a-dropdown
          :trigger="['click']"
          placement="topCenter"
          :getPopupContainer="
            (triggerNode) => {
              return triggerNode.parentNode || document.body;
            }
          "
        >
          <a class="ant-dropdown-link" @click.prevent>
            <span>{{
              provinceCode
                ? this.provinceData.filter(
                    (item) => item.code === provinceCode
                  )[0].name
                : "请选择"
            }}</span>
            <img src="../../assets/svg/down-arrow.svg" alt="" />
          </a>
          <template #overlay>
            <a-menu @click="handleProvince">
              <a-menu-item
                v-for="province in provinceData"
                :key="province.code"
                :value="province.code"
              >
                <span>{{ province.name }}</span>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
      <div class="city-choose-item">
        <div class="city-choose-item--title">市</div>
        <a-dropdown
          :trigger="['click']"
          placement="topCenter"
          :getPopupContainer="
            (triggerNode) => {
              return triggerNode.parentNode || document.body;
            }
          "
        >
          <a class="ant-dropdown-link" @click.prevent>
            <span>{{
              cityCode
                ? this.cityData.filter((item) => item.code === cityCode)[0].name
                : "请选择"
            }}</span>
            <img src="../../assets/svg/down-arrow.svg" alt="" />
          </a>
          <template #overlay>
            <a-menu @click="handleCity">
              <a-menu-item
                v-for="city in cityData"
                :key="city.code"
                :value="city.code"
              >
                <span>{{ city.name }}</span>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
      <div class="city-choose-item">
        <div class="city-choose-item--title">区</div>
        <a-dropdown
          :trigger="['click']"
          placement="topCenter"
          :getPopupContainer="
            (triggerNode) => {
              return triggerNode.parentNode || document.body;
            }
          "
        >
          <a class="ant-dropdown-link" @click.prevent>
            <span>{{
              areaCode
                ? this.areaData.filter((item) => item.code === areaCode)[0].name
                : "请选择"
            }}</span>
            <img src="../../assets/svg/down-arrow.svg" alt="" />
          </a>
          <template #overlay>
            <a-menu @click="handleArea">
              <a-menu-item
                v-for="area in areaData"
                :key="area.code"
                :value="area.code"
              >
                <span>{{ area.name }}</span>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
      <div class="city-choose-item search">
        <span></span>
        <input
          @change="changeSearchName"
          placeholder="请输入店铺名称按Enter键搜索"
          :value="this.searchName"
          type="text"
        />
        <img src="../../assets/svg/search.svg" alt="" />
      </div>
    </div>
    </div>
   
    <!-- 列表 -->
    <div class="content2">
      <div class="list" id="store-list-data">
        <div class="list-item" v-for="item in listData" :key="item.F_CompanyId">
          <div class="logo">
            <img :src="normalizeAssetUrl(item.F_Logo)" alt="logo" />
          </div>
          <div class="card-mid">
            <div class="card-mid--inner">
              <div class="item-title">{{ item.F_FullName }}</div>
              <div class="item-citys">
                {{ item.provinceName + item.cityName + item.countryName }}
              </div>
              <div class="item-items-bottom">
                <div class="item-address">
                  {{ item.F_Address }}
                </div>
                <a-divider
                  type="vertical"
                  style="height: 70%; border-color: #fff"
                />
                <div
                  class="item-address-icon"
                  @click="
                    () =>
                      handleMapNav(
                        item.F_Longitude,
                        item.F_Latitude,
                        item.F_Address,
                        item.F_FullName
                      )
                  "
                >
                  <i class="item-icon ri-send-plane-fill"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="item-right">
            <img />
          </div>
        </div>

        <div class="list-item" style="height: 12px"></div>
        <div class="pullup-tips">
          <div v-if="!isLoading & !isPullUpLoad&&pageData.length>8" class="before-trigger">
            <span class="pullup-txt">上拉加载更多数据</span>
          </div>
          <div v-if="!isLoading&!isPullUpLoad&&pageData.length===0" class="before-trigger">
            <span class="pullup-txt">暂无更多数据</span>
          </div>
          <div v-if="isLoading" class="after-trigger">
            <span class="pullup-txt">加载中...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "animate.css";
import "hover.css";
import provinceData from "./config/province";
import areaList from "./config/areaList";
import { throttle } from "lodash";
import BScroll from "@better-scroll/core";
import Pullup from "@better-scroll/pull-up";
import MouseWheel from "@better-scroll/mouse-wheel";
import axios from "axios";
import qs from "qs";
import { normalizeAssetUrl as normalizeLogoUrl } from "../../utils/asset-url";
BScroll.use(Pullup);
BScroll.use(MouseWheel);
export default {
  name: "black-vip-zone-selection4",
  components: {
  },
  created() {
    document.title = "找到INDIBA";
  },
  mounted() {
    this.initMouseScroll();
    this.onSearch();
    console.log("shengfen",this.provinceData)
  },
  watch: {
    provinceCode() {
      this.listData = [];
      this.cityName = "";
      this.onSearch();
    },
    cityCode() {
      this.listData = [];
      this.areaName = "";
      this.onSearch();
    },
    areaCode() {
      this.listData = [];
      this.onSearch();
    },
    searchName() {
      this.listData = [];
      this.onSearch();
    },
  },
  data() {
    return {
      provinceData,
      provinceCode: "",
      cityCode: "",
      areaCode: "",
      cityData: [],
      areaData: [],
      currentPage: 1,
      rows: 20,
      listData: [],
      searchName: "",
      settings: {
        suppressScrollY: false,
        suppressScrollX: false,
        wheelPropagation: false,
      },
      // 上拉加载
      isPullUpLoad: false,
      isLoading: false,
      pageData:[],
      data: 30,
    };
  },
  methods: {
    normalizeAssetUrl(url) {
      return normalizeLogoUrl(url);
    },
    // 地址导航
    handleMapNav(F_Longitude, F_Latitude, F_Address, F_FullName) {
      const params = { equipmentType: 'IA PRO MAX',F_Longitude, F_Latitude, F_Address, F_FullName };
      this.$router.push({
        path: "/map",
        query: params,
      });
    },
    // 省份变更
    handleProvince({ key }) {
      console.log("进入到这里")
      this.provinceCode = this.provinceData.filter(
        (item) => item.code === key
      )[0].code;
      this.cityData = this.provinceData.filter(
        (item) => item.code === key
      )[0].children;
    },
    // 市区变更
    handleCity({ key }) {
      this.cityCode = this.cityData.filter(
        (item) => item.code === key
      )[0]?.code;
      this.areaData = this.cityData.filter(
        (item) => item.code === key
      )[0]?.children;
    },
    // 区县变更
    handleArea({ key }) {
      this.areaCode = this.areaData.filter(
        (item) => item.code === key
      )[0]?.code;
    },
    // 搜索名字
    changeSearchName(val) {
      this.searchName = val.target.value;
    },
    // 搜索
    onSearch() {
      let params = {
        page: this.currentPage,
        rows: this.rows,
        equipmentType: 'IA PRO MAX'
      };
      if (this.searchName) {
        params.companyName = this.searchName;
      }
      if (this.provinceCode) {
        params.provinceId = this.provinceCode;
      }
      if (this.cityCode) {
        params.cityId = this.cityCode;
      }
      if (this.areaCode) {
        params.countyId = this.areaCode;
      }
      this.isLoading = true;
      axios
        .get(
          `/api/Company/GetMyPageList?&${qs.stringify(
            params
          )}`
        )
        .then((res) => {
          let tempList = res.data.data.rows;
          this.pageData = tempList;
          this.isLoading = false;
          tempList.forEach((item) => {
            item.provinceName = "";
            item.cityName = "";
            item.countryName = "";
            for (let i in areaList.province_list) {
              if (item.F_ProvinceId === i) {
                item.provinceName = areaList.province_list[i] || "";
              }
            }
            for (let i in areaList.city_list) {
              if (item.F_CityId === i) {
                item.cityName = areaList.city_list[i] || "";
              }
            }
            for (let i in areaList.county_list) {
              if (item.F_CountyId === i) {
                item.countryName = areaList.county_list[i] || "";
              }
            }
          });
          // 最后展示的数据
          this.listData.push(...tempList);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    // 初始化监听滚动
    initMouseScroll() {
      const listBox = document.getElementById("store-list-data");
      const handleScroll = async (e) => {
        let scrollTop = e.target.scrollTop;
        let clientHeight = e.target.clientHeight;
        let scrollHeight = e.target.scrollHeight;
        if (scrollHeight === scrollTop + clientHeight) {
          this.isPullUpLoad = true;
          this.isLoading = true;
          this.currentPage += 1;
          await this.onSearch();
          this.isPullUpLoad = false;
          this.isLoading = false;
        }
      };
      // 滚动节流
      const throttleHandleScroll = throttle(handleScroll, 1000);

      listBox.addEventListener("scroll", throttleHandleScroll);
    },
    // 初始化上拉刷新
    initBscroll() {
      this.scroll = new BScroll(this.$refs.scroll, {
        probeType: 3,
        pullUpLoad: true,
        mouseWheel: true,
      });
    },
   
    async pullingUpHandler() {
     
      this.isPullUpLoad = true;

      // await this.requestData();
      this.scroll.finishPullUp();
      this.scroll.refresh();
      this.isPullUpLoad = false;
    },
    // async requestData() {
    //   try {
    //     const newData = await this.ajaxGet(/* url */);
    //     this.data += newData;
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },
    // ajaxGet(/* url */) {
    //   return new Promise((resolve) => {
    //     setTimeout(() => {
    //       resolve(20);
    //     }, 1000);
    //   });
    // },
  },
};
</script>

<style lang="less" scoped>
.section4 {
  // background-image: url(../../assets/img/black-vip-bg-section3.png);
  background: #2e2c2c;
  background-size: cover;
  height: 100vh;
  position: relative;
  .bg {
    // black-vip-bg-section4
    background-image: url(../../assets/img/black-vip-bg-section4.png);
    background-size: cover;
    position: absolute;
    width: 100vw;
    height: 80vh;
    top: 0;
    left: 0;
  }
  .content-title {
    display: flex;
    position: relative;
    padding-top: 48px;
    margin-left: 10vw;
    min-width: 40vw;
    justify-content: flex-start;
    align-items: center;
    span {
      font-size: 36px;
      font-weight: bold;
      color: #ffffff;
    }
    img {
      height: 38px;
      width: auto;
      margin-right: 16px;
    }
  }
  .content1 {
    position: absolute;
    width: 92%;
    left: 50%;
    transform: translateX(-50%);
    top: 128px;
    z-index: 1000000;
    .choose-address {
    // position: absolute;
    // width: 92%;
    // left: 50%;
    // transform: translateX(-50%);
    // top: 128px;
    display: flex;
    justify-content: space-around;
    padding: 0 16px;
    .city-choose-item {
      width: 210px;
      border-bottom: 2px solid white;
      .ant-dropdown-link {
        margin: 16px 0;
        display: flex;
        justify-content: space-between;
        span {
          color: #fff;
          font-size: 15px;
        }
        img {
          width: 18px;
          margin-left: 8px;
        }
      }
      .ant-dropdown {
        z-index: 99999 !important;
        .ant-dropdown-menu {
          max-height: 200px;
          overflow: scroll;
        }
      }
    }
    .search {
      display: flex;
      justify-content: flex-end;
      align-items: end;
      input {
        height: 32px;
        width: 100%;
        border: none;
        outline: none;
        background-color: transparent;
        color: #fff;
      }
      ::placeholder {
        color: #fff;
      }
      img {
        width: 18px;
        height: 18px;
        margin-bottom: 6px;
      }
    }
    .city-choose-item--title {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      font-weight: bold;
    }
  }
  }
  
  .content2 {
    position: absolute;
    top: 32vh;
    background-color: transparent;
    width: 100%;
    display: flex;
    justify-content: center;
    min-height: 250px;
    .list {
      width: 82%;
      display: flex;
      flex-flow: row wrap;
      justify-content: space-around;
      margin-top: 16px;
      max-height: 500px;
      overflow-y: scroll;
      &::-webkit-scrollbar-track {
        background-color: #4c4c55;
      }

      &::-webkit-scrollbar {
        width: 8px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #ffffff;
      }

      .list-item {
        display: flex;
        height: 150px;
        flex: 0 0 45%;
        min-width: 440px;
        .logo {
          display: flex;
          align-items: center;
          margin-right: 30px;
          img {
            width: 100px;
            height: 90px;
            background-color: #fff;
            object-fit: contain;
          }
        }
        .card-mid {
          width: 380px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .card-mid--inner {
            background-color: #464546;
            opacity: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            border-radius: 6px;
            padding: 10px;
            color: white;
            .item-title {
              font-size: 18px;
              font-weight: 700;
              color: #fff;
              margin-bottom: 6px;
            }
            .item-citys,
            .item-address {
              font-size: 13px;
              flex: 1;
            }
            .item-address-icon {
              text-align: right;
              cursor: pointer;
            }
            .item-items-bottom {
              display: flex;
              align-items: center;
              width: 100%;
            }
          }
        }
      }
    }
  }
  .pullup-tips {
    width: 100%;
    text-align: center;
    color: #e9dfdf;
    margin: 12px;
  }
}
</style>
